export const parseGroupMembersNames = (name: string): string[] => {
  const parsedName1 = name
    .split(/\n|\|/)
    .map(val => val.trim())
    .filter(val => Boolean(val));

  return parsedName1;
};

/*export const parseGroupMembersNames = (namesInput: string): string[] => {
  return namesInput.split('\n');
};*/

export const parseGroupMembersNamesToInput = (namesArr: string[]) => {
  if (namesArr?.length === 1 && namesArr[0].includes('|'))
    namesArr = parseGroupMembersNames(namesArr[0]);

  return namesArr.join('\n');
};
